// src/components/ui/Input.tsx
//
// Text input primitive. Polished, dark-mode optimized.

import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, type = "text", ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      className={cn(
        "h-9 w-full rounded border border-border bg-bg-surface px-3 py-1.5",
        "text-sm text-fg-primary placeholder:text-fg-tertiary",
        "transition-colors focus:border-accent-indigo focus:outline-none",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...rest}
    />
  );
});
